import { MixedDataPoint } from '.';

export function findKeyOfMaxNumber(data: MixedDataPoint[]): string {
  let maxKey = 'y';
  let maxValue = -Infinity;

  for (const item of data) {
    for (const key in item) {
      const value = item[key];
      if (typeof value === 'number' && value > maxValue) {
        maxValue = value;
        maxKey = key;
      }
    }
  }

  return maxKey;
}

export function findStringKey(data: MixedDataPoint[]): string {
  for (const item of data) {
    for (const key in item) {
      if (typeof item[key] === 'string') {
        return key;
      }
    }
  }
  return '';
}

export function getNumberKeys(array: MixedDataPoint[]): string[] {
  const keys: string[] = [];
  array.forEach((obj) => {
    for (const key in obj) {
      if (typeof obj[key] === 'number' && !keys.includes(key)) {
        keys.push(key);
      }
    }
  });
  return keys;
}

export function getColorByPosition(arr: string[], input: number): string | undefined {
  if (arr.length !== 10) {
    throw new Error("L'array deve contenere esattamente 10 elementi.");
  }

  switch (input) {
    case 0:
      return arr[0];
    case 1:
      return arr[5];
    case 2:
      return arr[1];
    case 3:
      return arr[6];
    case 4:
      return arr[2];
    case 5:
      return arr[7];
    case 6:
      return arr[3];
    case 7:
      return arr[8];
    case 8:
      return arr[4];
    case 9:
      return arr[9];
  }
}

export const filterZeroKeys = (data: MixedDataPoint[]): MixedDataPoint[] => {
  if (data.length === 0) return [];
  const keys = Object.keys(data[0] || []);

  const keysAlwaysZero = keys.filter((key) => data.every((item) => item[key] === 0));

  return data.map((item) => {
    const newItem: MixedDataPoint = {};
    Object.entries(item).forEach(([key, value]) => {
      if (!keysAlwaysZero.includes(key)) {
        newItem[key] = value;
      }
    });
    return newItem;
  });
};
